import React from 'react';
import * as MyCells from '../../../../../utils/Cells';
import * as enums from '../../../../../utils/EnumMapping';
import ActionMenu from '../../../../common/action/ActionMenu';
import StatusCell from '../../../../common/cells/StatusCell';
import { MultiSelectFilterFn } from '../../../../common/filters/Filters';
import MultiSelectColumnFilter from '../../../../common/filters/MultiSelectColumnFilter';
import StateMultiSelectColumnFilter, { StateMultiSelectFilterFn } from '../../../../common/filters/StateMultiSelectColumnFilter';
import TextColumnFilter from '../../../../common/filters/TextColumnFilter';

export const columns = (refresh) => {
    return [
        {
            Header: 'Státusz',
            accessor: 'stateLabel',
            id: 'stateLabel',
            show: true,
            className: 'status',
            Filter: StateMultiSelectColumnFilter,
            filter: StateMultiSelectFilterFn,
            Cell: props => <StatusCell row={props.row.original} />,
        },
        {
            Header: 'Sorszám',
            accessor: 'publicId',
            id: 'publicId',
            show: true,
            className: 'idColumn center',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Csoport sorszám',
            accessor: 'groupPublicId',
            id: 'groupPublicId',
            show: true,
            className: 'idColumn center',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Munkavállaló',
            accessor: 'employeeName',
            id: 'employeeName',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Letiltás partner',
            accessor: 'restrainPartnerName',
            id: 'restrainPartnerName',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Fizetési mód',
            accessor: 'paymentMethodLabel',
            id: 'paymentMethodLabel',
            show: true,
            className: 'iconColumn',
            Filter: MultiSelectColumnFilter,
            filter: MultiSelectFilterFn,
            Cell: props => <MyCells.IconCell label={props.value} list={enums.paymentMethods} />,
        },
        {
            Header: 'Év',
            accessor: 'salaryYear',
            id: 'salaryYear',
            show: true,
            className: 'idColumn right',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Hónap',
            accessor: 'salaryMonth',
            id: 'salaryMonth',
            show: true,
            className: 'idColumn right',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Összeg',
            accessor: 'amount',
            id: 'amount',
            show: true,
            className: 'right amountColumn',
            Filter: TextColumnFilter,
            Cell: props => <MyCells.NumberCell value={props.value} />,
        },
        {
            Header: 'Megjegyzés',
            accessor: 'comment',
            id: 'comment',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            id: 'menu',
            show: true,
            headerClassName: 'actions',
            className: 'actions',
            Header: () => null, // No header
            Cell: value => <ActionMenu row={value.row.original} tabletype={'restrain'} refresh={refresh} />,
        },
    ]
}